import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import store from './stores';
import MainLayout from './layouts/MainLayout';
import sectionsData from './data/sections.json';
import RealityLayersViz from './posts/reality-layers/visualizations/RealityLayersViz';
import ApothecaryPage from './examples/apothecary/ApothecaryPage';

// Import sections
import Hero from './components/Hero';
import Blog from './components/Blog';
import WorkExperience from './components/WorkExperience';
import Life from './components/Life';
import Contact from './components/Contact';

const RealityLayersFullscreen = () => {
  const navigate = useNavigate();
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 50, background: '#030508' }}>
      <RealityLayersViz />
      <button
        onClick={() => navigate('/blog?post=reality-layers')}
        style={{
          position: 'absolute', top: 20, right: 20, zIndex: 100,
          background: 'rgba(255,255,255,0.05)',
          border: '1px solid rgba(255,255,255,0.13)',
          color: 'rgba(255,255,255,0.4)',
          padding: '5px 12px',
          fontFamily: 'Inter, system-ui, sans-serif',
          fontSize: 10, fontWeight: 500,
          cursor: 'pointer', borderRadius: 3,
          letterSpacing: '0.08em', textTransform: 'uppercase',
        }}
      >
        ← Back
      </button>
    </div>
  );
};

const AppContent = () => {
  const location = useLocation();

  if (location.pathname === '/viz/reality-layers') {
    return <RealityLayersFullscreen />;
  }

  if (location.pathname === '/examples/apothecary') {
    return <ApothecaryPage />;
  }

  return (
    <MainLayout>
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Hero data={{ background: 'cody' }} />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/work" element={<WorkExperience />} />
          <Route path="/life" element={<Life />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </AnimatePresence>
    </MainLayout>
  );
};

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AppContent />
      </Router>
    </Provider>
  );
}

export default App;